import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
export function getContactLink(vid) {
  return vid ? `${getFullUrl('app')}/contacts/${PortalIdParser.get()}/contact/${vid}` : '';
}